import { render, staticRenderFns } from "./newAsset.vue?vue&type=template&id=047b62c9&"
import script from "./newAsset.vue?vue&type=script&lang=js&"
export * from "./newAsset.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports